export default {
  name: "email-verification-verified",
  components: {},
  props: [],
  data() {
    return {
      baseURL: process.env.VUE_APP_PUBLIC_BASE_URL
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
